import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  getCurrentURL(): string {
    let url = location.href;
    const lastIndex = url.lastIndexOf('?');
    if (lastIndex !== -1) {
      url = url.substring(0, lastIndex);
    }
    return url;
  }

  getImageSrc(imageName: string): string {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return `/assets/platform-integrations/${imageName}`;
    }
    return `https://vstatic-prod.apigateway.co/business-center-client.9223372035102012180.prod/assets/platform-integrations/${imageName}`;
  }
}
